import { EntityRepository, Repository, getManager } from "typeorm";
import { AdjustmentNotesEntity } from "../entity/adjustment-note.entity";
import { AdjustmentNoteCategoryEnum } from "@gtpl/shared-models/common-models";
import { AdjutsmentNoteCategoryReq } from "@gtpl/shared-models/finance";
import appSettings from "apps/services/config";

@EntityRepository(AdjustmentNotesEntity)
export class AdjustmentNoteRepository extends Repository<AdjustmentNotesEntity>{

    async getNoteCount(category):Promise<any>{
        const columnName = category == AdjustmentNoteCategoryEnum.CREDIT ? 'credit_note_no' : 'debit_note_no'
        let infoQuery = this.createQueryBuilder('an')
        .select(`GROUP_CONCAT(DISTINCT(${columnName})) as id`)
        .where(`category = '${category}'`)
        .orderBy(`created_at`, 'DESC')
        return await infoQuery.getRawOne()
    }

    async getAdjustmentNoteInfo(req:AdjutsmentNoteCategoryReq):Promise<any>{
        const manager = getManager()
        let infoQuery = `SELECT an.category,an.vendor_id,an.debit_note_no,an.credit_note_no,an.invoice_no,an.po_id,an.item_id,an.price,an.quantity,an.tax_amount,an.total_amount,i.item_name,an.adjustment_notes_id,
        an.grn_item_id,an.grn_id,an.tax_percentage,v.vendor_code,v.vendor_name,gi.sale_order_id,g.grn_no,soi.po_number AS saleordernumber,po.po_number
        FROM ${appSettings.finance_db} .adjustment_notes an
        LEFT JOIN ${appSettings.masters_db} .vendors v ON v.vendor_id = an.vendor_id
        LEFT JOIN ${appSettings.masters_db} .items i ON i.item_id = an.item_id
        LEFT JOIN ${appSettings.procure_db} .grn_items gi ON gi.grn_item_id = an.grn_item_id
        LEFT JOIN ${appSettings.procure_db} .grn g ON g.grn_id = an.grn_id
        LEFT JOIN ${appSettings.sales_db} .so_invoice_details soi ON soi.sale_order_id = gi.sale_order_id
        LEFT JOIN ${appSettings.procure_db} .purchase_order po ON po.purchase_order_id = an.po_id
        WHERE an.category ='${req.category}'`
        if(req.noteNumber && req.category == AdjustmentNoteCategoryEnum.DEBIT){
            infoQuery += ` and an.debit_note_no = '${req.noteNumber}'`
        }
        if(req.noteNumber && req.category == AdjustmentNoteCategoryEnum.CREDIT){
            infoQuery += ` and an.credit_note_no = '${req.noteNumber}'`
        }
        if(req.invoiceNumber){
            infoQuery += ` and an.invoice_no = '${req.invoiceNumber}'`
        }
        infoQuery += ` ORDER BY an.created_at`
        return await manager.query(infoQuery)
        
    }

    async getNoteNumberDropDown(req:AdjutsmentNoteCategoryReq):Promise<any>{
        const manager = getManager()
        let infoQuery = `SELECT an.debit_note_no as debitNoteNumber,an.credit_note_no as creditNoteNumber FROM ${appSettings.finance_db} .adjustment_notes an WHERE an.category = '${req.category}' GROUP BY an.debit_note_no,an.credit_note_no ORDER BY an.created_at`
        return await manager.query(infoQuery)
    }

    async getInvoiceNumberDropDown(req:AdjutsmentNoteCategoryReq):Promise<any>{
        const manager = getManager()
        let infoQuery = `SELECT an.invoice_no as invoiceNumber FROM ${appSettings.finance_db} .adjustment_notes an WHERE an.category = '${req.category}' GROUP BY an.invoice_no ORDER BY an.created_at`
        return await manager.query(infoQuery)
    }

    async getVendorDropDown(req:AdjutsmentNoteCategoryReq):Promise<any>{
        const manager = getManager()
        let infoQuery = `SELECT v.vendor_name as vendorName, v.vendor_code as vendorCode,an.vendor_id as vendorId FROM ${appSettings.finance_db} .adjustment_notes an 
        LEFT JOIN ${appSettings.masters_db} .vendors v on v.vendor_id = an.vendor_id
        WHERE an.category = '${req.category}' GROUP BY an.vendor_id  ORDER BY an.created_at`
        return await manager.query(infoQuery)
    }


}